import React from "react"
import classNames from "classnames"
import {EditMode, formatCurrency} from "./utils"

export function RevertLimitSection({
	editMode,
	setEditMode,
	depositProductLimit,
}: {
	editMode: EditMode
	setEditMode: (mode: EditMode) => void
	depositProductLimit: number
}) {
	return (
		<div
			className={classNames(
				"limit-override-mode-selector",
				"limit-override-mode-selector--border",
				"limit-override-mode-selector--revert",
				editMode === EditMode.Revert && "limit-override-mode-selector--selected"
			)}
			onClick={() => setEditMode(EditMode.Revert)}
		>
			<span className="limit-override-radio">
				<input
					type="radio"
					name="editMode"
					value={EditMode.Revert}
					checked={editMode === EditMode.Revert}
					onChange={() => setEditMode(EditMode.Revert)}
				/>
				<div className="limit-override-radio-content">
					<span className="limit-override-radio-label">
						Revert to Default Limit <span className="limit-override-radio-label-default">(default)</span>
					</span>
					<span className="limit-override-radio-description">This will cancel existing override</span>
				</div>
			</span>
			<span className="limit-override-revert-amount">{formatCurrency(depositProductLimit)}</span>
		</div>
	)
}
